
<template>
  <div>
    <div class="train">
      <div class="container">
          <div class="title-box clearfix">
              <div class="list">
                  <ul class="clearfix">
                      <li class="active">专题培训</li>
                  </ul>
              </div>
              <!-- <div class="link">
                  <a href="http://www.cnzyjy.org.cn/">
                      <i class="fa fa-envelope-o"></i>
                      <span>网管信箱</span>
                  </a>
              </div> -->
          </div>
          <div class="imgList" v-if="Groups[0]">
              <ul class="clearfix">
                  <li v-for="(article , index) in  Groups[0].articles" :key="index">
                      <router-link :to="`/news/info/${article.plateid}/${article._id}`">
                          <img :src="`${global.remoteIp}/uploads/${article.picsrc}`">
                      </router-link>
                  </li>
              </ul>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  props: {
    plates: Array,
    platename: String,
  },
  components: {},
  data() {
    return {
      articles: [],
      plateId: "",
      global,
      Groups:[
        {
          name: "专题培训",
          plateid: "",
        },
      ]
    };
  },
  mounted() {
    for (let k = 0; k < this.Groups.length; k++) {
      for (let j = 0; j < this.plates.length; j++) {
        if (this.Groups[k].name == this.plates[j].name) {
          this.Groups[k].plateId = this.plates[j]._id;
          this.$axios
            .get(
              `/api/articles?plateid=${this.Groups[k].plateId}&sort=-createdAt&limit=5`
            )
            .then((res) => {
              if (res.data) {
                this.Groups[k].articles = this.global
                  .sortByTop(res.data.data);
                this.$forceUpdate();
              }
            });
          break;
        }
      }
    }
  },
};
</script>
<style scoped>
</style>
